import styled from 'styled-components';
import { Card } from 'antd';
import colors from 'theme/colors';

export const CardGridStyled = styled(Card.Grid)`
  display: flex;
  justify-content: space-between;
  padding-right: 3.75rem;
  width: 100%;
  padding: 0;
  box-shadow: none;
  &:hover {
    box-shadow: none;
  }
  margin-bottom: 0.625rem;
`;

export const InfoItemStyled = styled.div`
  width: 11.563rem;
  position: relative;
  display: flex;
  flex-direction: column;
  .ant-typography {
    max-width: 14.75rem;
    &.email-wrap {
      white-space: pre;
      text-wrap: balance;
    }
  }
  .anticon-link {
    position: absolute;
    left: 11.625rem;
    top: 1.563rem;
    color: ${colors.primary};
    cursor: pointer;
  }
`;

export const CardGridLinkStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 0.75rem;
  border-top: 0.063rem solid rgba(0, 0, 0, 0.07);
  position: absolute;
  left: 0;
  bottom: 0;
  padding-bottom: 0.79rem;
  a {
    font-family: Sarabun;
    font-style: normal;
    font-weight: bold;
    font-size: 0.75rem;
    line-height: 1.563rem;
    ine-height: 1.563rem;
  }
`;
